'use client'

import { CalendarDays } from 'lucide-react'
import {
  AssessmentButton,
  BookingButton,
} from '@/components/attention-deficit-hyperactivity-disorder-therapy/shared'

const StickyCTA: React.FC = () => {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-2.5 sm:py-3 flex flex-col sm:flex-row gap-2 sm:gap-3 items-center justify-between">
        <div className="flex items-center gap-2 sm:gap-3 text-xs sm:text-sm text-center sm:text-left">
          <CalendarDays className="h-4 w-4 sm:h-5 sm:w-5 shrink-0 hidden sm:block" />
          <span>
            Ready to start? Take the free ADHD self-assessment or book now.
          </span>
        </div>
        <div className="flex gap-2 sm:gap-3 w-full sm:w-auto">
          <AssessmentButton variant="outline" size="default" />
          <BookingButton size="default" />
        </div>
      </div>
    </div>
  )
}

export default StickyCTA
